import { CodeBook } from "@king-ict/eupisi-ui/models";

import { CommitteeEmployee } from "./CommitteeEmployee";

export interface Committee {
    id: number;
    dateFrom?: Date;
    dateTo?: Date;
    note?: string;
    statusId: CommitteeStatus;
    employees?: CommitteeEmployee[];

    // These are helper properties
    isSelected: boolean;
}

export enum CommitteeStatus {
    NotDefined = 1,
    ConfirmationRequired,
    Rejected,
    Granted,
}

export interface Institution extends CodeBook {
    oib: string;
    code: string;
    subCode: string;
    typeId?: number;
    statudId?: number;
    address?: InstitutionAddress;
}

export interface InstitutionAddress {
    addressLine1: string;
    addressLine2: string;
    town: CodeBook;
}
